import { parametric, pathSubscription, subscription } from 'nike-re-framejs';
import { List, Map } from 'immutable';
import { nuiCtx } from '../../common/initialization';

const betslipServerPortal$ = pathSubscription(['betslip', 'server']);
const betslipServerMobile$ = pathSubscription(['server']);
const activeBetslipIndex$ = pathSubscription(['betslip', 'activeBetslipIndex'], 0);

const betslipServer$ = subscription(
    (portal, mobile) => (nuiCtx.platform === 'portal' ? portal : mobile),
    betslipServerPortal$,
    betslipServerMobile$
);

const betslip$$ = (index: number) => subscription(betslip => betslip.getIn(['betslips', index]), betslipServer$);

export const betslipPicksBySelectionId$$ = (index: number) =>
    subscription(betslip => extractBetslipPicks(betslip), betslip$$(index));

export const selectedPicksById$ = subscription(
    (betslip, activeIndex) => extractBetslipPicks(betslip?.getIn(['betslips', activeIndex])),
    betslipServer$,
    activeBetslipIndex$
);

export const betslipByActiveIndex$ = subscription(
    (betslip, activeIndex) => {
        const betslips = betslip?.getIn(['betslips']);
        return betslips?.filter(betslip => betslip.get('index') === activeIndex).first();
    },
    betslipServer$,
    activeBetslipIndex$
);

export const isPickSelected$$ = parametric((pickId: string) =>
    subscription(betslip => extractBetDetailFromBetslipByPickId(betslip, pickId), betslipByActiveIndex$)
);

const extractBetDetailFromBetslipByPickId = (betslip, pickId) => {
    const selectedPickDetails = extractBetInfo(betslip, pickId);
    return {
        isSelected: !!selectedPickDetails,
        betbookId: selectedPickDetails?.get('betbookId'),
        betbookContractId: selectedPickDetails?.get('betbookContractId'),
        positionCode: selectedPickDetails?.get('positionCode'),
        positionId: selectedPickDetails?.get('positionId')
    };
};

export const isPickSelectedOnOtherBetslip$$ = parametric((pickId: string) =>
    subscription(
        (betslips, activeIndex) => {
            const result = betslips?.get('betslips')?.map(betslip => {
                if (betslip.get('index') === activeIndex) return {};
                return extractBetDetailFromBetslipByPickId(betslip, pickId);
            });
            const filteredSelectedBets = result?.toJS().filter(({ isSelected }) => isSelected);
            return {
                isSelectedOther: filteredSelectedBets?.length > 0,
                filteredSelectedBets
            };
        },
        betslipServer$,
        activeBetslipIndex$
    )
);

export function extractBetslipPicks(betslip) {
    return betslip?.get('groups').flatMap(group =>
        // different format in reframe DB portal vs mobile
        nuiCtx.platform === 'portal' ? group.get('picks') : indexBy(group.get('picks'), 'selectionId')
    );
}

export function extractBetInfo(betslip, betId) {
    return extractBetslipPicks(betslip)
        ?.filter((_, key) => key === betId)
        .first();
}

function indexBy(list: List<Map<string, any>>, property: string) {
    return list.reduce((map, item) => map.set(item.get(property), item), Map());
}

export const betslipPick$$ = (selectionId: string, index: number) =>
    subscription(picksBySelectionId => picksBySelectionId?.get(selectionId), betslipPicksBySelectionId$$(index));

export const getPickId = (betId, selectionCode) => `${betId}-${selectionCode}`;
